const types = {
    FETCH_LIST_START: 'FETCH_LIST_START',
    FETCH_LIST_ERROR: 'FETCH_LIST_ERROR',
    FETCH_LIST_SUCCESS: 'FETCH_LIST_SUCCESS',
    FETCH_AUTOCOMPLETE_START: 'FETCH_AUTOCOMPLETE_START',
    FETCH_AUTOCOMPLETE_ERROR: 'FETCH_AUTOCOMPLETE_ERROR',
    FETCH_AUTOCOMPLETE_SUCCESS: 'FETCH_AUTOCOMPLETE_SUCCESS'
}

export default types;



// WEBPACK FOOTER //
// ./src/store/modules/person/mutation-types.js